import React from 'react'

const Login = React.lazy(() => import('src/views/common/login/Login'))
const StudentDashboard = React.lazy(() => import('src/views/student/Dashboard'))
const teacherDashboard = React.lazy(() => import('src/views/teacher/Dashboard'))
const Register = React.lazy(() => import('src/views/common/register/Register'))
const EditProfile = React.lazy(() => import('src/views/common/viewProfile/ViewProfile'))
const AddProfile = React.lazy(() => import('src/views/common/addProfile/AddProfile'))
const Tests = React.lazy(() => import('src/views/teacher/Questions'))
const CreateTest = React.lazy(() => import('src/views/teacher/CreateExam'))
const AddQuestions = React.lazy(() => import('src/views/teacher/AddQuestions'))
const ViewQuestions = React.lazy(() => import('src/views/teacher/ViewQuestions'))
const Exams = React.lazy(() => import('src/views/teacher/Exams'))
const AddQuestionsToTest = React.lazy(() => import('src/views/teacher/AddExamQuestions'))
const TakeTest = React.lazy(() => import('src/views/teacher/TakeTest'))
const TestSummary = React.lazy(() => import('src/views/teacher/TestSummary'))
const TeacherVerification = React.lazy(() => import('src/views/teacher/TeacherVerification'))
const Exercises = React.lazy(() => import('src/views/teacher/Exercises'))
const CreateExercises = React.lazy(() => import('src/views/teacher/CreateExercises'))
const AddExercisesQuestions = React.lazy(() => import('src/views/teacher/AddExercisesQuestions'))
const StudentTakeTest = React.lazy(() => import('src/views/student/StudentTakeTest'))
const groupsDetails = React.lazy(() => import('src/views/student/GroupsDetails'))
const MergeAcademics = React.lazy(() => import('src/views/admin/MergeAcademics'))
const Users = React.lazy(() => import('src/views/admin/Users'))
const AdminDashboard = React.lazy(() => import('src/views/admin/Dashboard'))
const VerifierDashboard = React.lazy(() => import('src/views/verifier/Dashboard'))
const VerifierVerificationPage = React.lazy(() => import('src/views/verifier/VerificationPage'))
const VerifierExercises = React.lazy(() => import('src/views/verifier/Exercises'))
const VerifierExams = React.lazy(() => import('src/views/verifier/Exams'))
const EditUsers = React.lazy(() => import('src/views/admin/EditUsers'))
const AdminExercises = React.lazy(() => import('src/views/admin/Exercises'))
const AdminExams = React.lazy(() => import('src/views/admin/Exams'))
const TakeTestIntroPage = React.lazy(
  () => import('src/components/features/student/TakeTestIntroPage'),
)
const TestResult = React.lazy(() => import('src/views/student/StudentTestResults'))
const StudentTestResult = React.lazy(() => import('src/views/student/StudentTestResults'))
const homeRoutes = [
  { path: '/', exact: true, name: 'Login', element: Login },
  { path: '/login', exact: true, name: 'Login', element: Login },
  { path: '/register', exact: true, name: 'Register', element: Register },
  { path: '/add-profile', exact: true, name: 'AddProfile', element: AddProfile },
]

const studentRoutes = [
  { path: '/', exact: true, name: 'student', element: StudentDashboard },
  { path: '/profile', exact: true, name: 'EditProfile', element: EditProfile },
  { path: '/group-details', exact: true, name: 'StudentTests', element: groupsDetails },
  { path: '/take-test', exact: true, name: 'StudentTakeTest', element: StudentTakeTest },
  { path: '/take-test/result', exact: true, name: 'StudentTestResult', element: StudentTestResult },
  { path: '/take-test/review', exact: true, name: 'StudentTestReview', element: StudentTakeTest },
  {
    path: '/test-intro/:testKey',
    exact: true,
    name: 'TakeTestIntroPage',
    element: TakeTestIntroPage,
  },
  {
    path: '/take-test/result/:testCode',
    exact: true,
    name: 'TestResult',
    element: TestResult,
  },
]

const teacherRoutes = [
  { path: '/', exact: true, name: 'teacher', element: teacherDashboard },
  { path: '/profile', exact: true, name: 'EditProfile', element: EditProfile },
  { path: '/questions', exact: true, name: 'Tests', element: Tests },
  { path: '/add-questions', exact: true, name: 'AddQuestions', element: AddQuestions },
  { path: '/view-question', exact: true, name: 'Quiz', element: ViewQuestions },
  { path: '/edit-question', exact: true, name: 'AddQuestions', element: AddQuestions },
  { path: '/create-exams', exact: true, name: 'CreateTest', element: CreateTest },
  {
    path: '/add-exams-questions',
    exact: true,
    name: 'AddQuestionsToTest',
    element: AddQuestionsToTest,
  },
  { path: '/exams', exact: true, name: 'Exams', element: Exams },
  { path: '/edit-exams', exact: true, name: 'CreateTest', element: CreateTest },
  { path: '/take-test', exact: true, name: 'TakeTest', element: TakeTest },
  { path: '/test-summary', exact: true, name: 'TestSummary', element: TestSummary },
  { path: '/exams-verification', exact: true, name: 'TestSummary', element: TeacherVerification },
  { path: '/archive-exams', exact: true, name: 'archive', element: Exams },
  { path: '/exercises', exact: true, name: 'Exercises', element: Exercises },
  { path: '/create-exercises', exact: true, name: 'CreateExercises', element: CreateExercises },
  { path: '/edit-exercises', exact: true, name: 'CreateExercises', element: CreateExercises },
  {
    path: '/add-exercises-questions',
    exact: true,
    name: 'AddExercisesQuestions',
    element: AddExercisesQuestions,
  },
  { path: '/archive-exercises', exact: true, name: 'archive', element: Exercises },
  {
    path: '/exercises-verification',
    exact: true,
    name: 'TestSummary',
    element: TeacherVerification,
  },
]

const adminRoutes = [
  { path: '/', exact: true, name: 'Admin', element: AdminDashboard },
  { path: '/profile', exact: true, name: 'EditProfile', element: EditProfile },
  { path: '/classes', exact: true, name: 'MergeClasses', element: MergeAcademics },
  { path: '/subjects', exact: true, name: 'MergeSubjects', element: MergeAcademics },
  { path: '/topics', exact: true, name: 'MergeTopics', element: MergeAcademics },
  { path: '/sub-topics', exact: true, name: 'MergeSubTopics', element: MergeAcademics },
  { path: '/test-types', exact: true, name: 'MergeTestTypes', element: MergeAcademics },
  { path: '/users', exact: true, name: 'Users', element: Users },
  { path: '/edituser', exact: true, name: 'EditUsers', element: EditUsers },
  { path: '/exercises', exact: true, name: 'Exercises', element: AdminExercises },
  { path: '/exams', exact: true, name: 'AdminExams', element: AdminExams },
]
const VerifierRoutes = [
  { path: '/', exact: true, name: 'student', element: VerifierDashboard },
  { path: '/profile', exact: true, name: 'EditProfile', element: EditProfile },
  { path: '/verify', exact: true, name: 'Verify', element: VerifierVerificationPage },
  { path: '/exercises', exact: true, name: 'Exercises', element: VerifierExercises },
  { path: '/exams', exact: true, name: 'Exams', element: VerifierExams },
  { path: '/take-test', exact: true, name: 'TakeTest', element: TakeTest },
  { path: '/test-summary', exact: true, name: 'TestSummary', element: TestSummary },
]

export { homeRoutes, studentRoutes, teacherRoutes, adminRoutes, VerifierRoutes }
